import React, {useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import Header from './Header.jsx';           // ваш компонент шапки
import klukvaImg from '../images/klukva.jpg'; // пример картинки
import '../style/CakeDetail.css';

const CakeDetailCran = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const navigate = useNavigate();

  return (
    <>
      <Header />

      <div className="detail-container">
        <div className="detail-text">
          <h2>Наполеон с клюквой</h2>
          <p>Осенняя ягода, которая добавит торту освежающую кислинку.</p>
          <p><strong>Вес:</strong> 1,2&nbsp;кг</p>
          <p><strong>Цена:</strong> 2300&nbsp;₽</p>
          <button onClick={() => navigate(-1)} className="back-button">
            ← Назад
          </button>
        </div>

        <div className="detail-image">
          <img src={klukvaImg} alt="Наполеон Классический" />
        </div>
      </div>
    </>
  );
};

export default CakeDetailCran;
